import {css} from '../theme/css'
import {spacing, theme} from '../theme/theme'
import {cssTheme} from '../theme'

export const classes = {
  root: css`
    font-size: ${cssTheme.fonts.sizes.body1};
    margin: ${spacing(2.25, 0)};
    font-weight: ${cssTheme.fonts.weights.medium};
    text-transform: capitalize;
    ${theme.breakpoints.up('md')} {
      font-size: ${cssTheme.fonts.sizes.title2};
      line-height: ${cssTheme.fonts.heights.title2.normal};
      letter-spacing: ${cssTheme.fonts.spacings.title2.medium};
      margin: ${spacing(7, 0, 2, 0)};
    }
  `,
}
